"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutUs() {
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="about-us" className="bg-background py-16 md:py-24 px-6 md:px-12 lg:px-20">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div ref={imageRef} className="transition-all duration-700 ease-out" style={{
          opacity: imageVisible ? 1 : 0,
          transform: imageVisible ? "translateY(0)" : "translateY(48px)"
        }}>
            <div className="relative overflow-hidden rounded-lg shadow-medium">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1508208/img/ballet_studio_interior.png" alt="Professional ballet studio interior at Live Entertainment, LLC" className="w-full h-auto object-cover" />
            </div>
          </div>

          {}
          <div ref={textRef} className="transition-all duration-700 ease-out" style={{
          opacity: textVisible ? 1 : 0,
          transform: textVisible ? "translateY(0)" : "translateY(48px)"
        }}>
            <div className="space-y-6">
              <h2 className="font-display text-4xl md:text-5xl font-bold text-foreground leading-tight">
                About Us
              </h2>
              
              <div className="h-1 w-20 bg-accent rounded-full"></div>
              
              <p className="text-foreground text-lg leading-relaxed">
                Live Entertainment, LLC is a Professional Ballet School International delivering fine arts education and classical ballet training. Based in Tujunga, CA, our institution emphasizes structured, curriculum-based instruction, discipline, technique, and artistic development.
              </p>
              
              <p className="text-foreground text-lg leading-relaxed">
                We foster a rigorous yet supportive environment where aspiring dancers refine their craft under experienced faculty. Our international reputation reflects a commitment to excellence, cultural exchange, and the cultivation of artistic talent within a trusted, professional setting.
              </p>
              
              <p className="text-foreground text-lg leading-relaxed">
                Programs are presented as educational, not entertainment-based, and cater to students from beginner to advanced levels. We believe in the transformative power of classical ballet as a cornerstone of fine arts education.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}